import { Permission } from "models/abac";

const permissionOptions = Object.values(Permission);

export { permissionOptions };
